// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SiHaDocumentationListModel from '../../model/si-ha-documentation-list-model';
import SiHaDocumentationListDTO from '../dto/si-ha-documentation-list-dto';
import dtoSchema from '../schemas/si-ha-documentation-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SiHaDocumentationListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SiHaDocumentationListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.siHaDocumentationStatus = data.siHaDocumentationStatus;
      this.title = data.title ?? undefined;
      this.remark = data.remark ?? undefined;
      this.projectNumber = data.projectNumber ?? undefined;
      this.clientCompanyName = data.clientCompanyName ?? undefined;
      this.clientAddressLine = data.clientAddressLine ?? undefined;
      this.clientPostalCode = data.clientPostalCode ?? undefined;
      this.clientCity = data.clientCity ?? undefined;
      this.clientFirstName = data.clientFirstName ?? undefined;
      this.clientLastName = data.clientLastName ?? undefined;
      this.clientEMail = data.clientEMail ?? undefined;
      this.clientPhoneNumber = data.clientPhoneNumber ?? undefined;
      this.addressLine = data.addressLine ?? undefined;
      this.city = data.city ?? undefined;
      this.postalCode = data.postalCode ?? undefined;
      this.nextInspectionDueDate = data.nextInspectionDueDate ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int32}
  */
  siHaDocumentationStatus?: 1 | 2 | 3 | 4 | 5; // SiHaDocumentationStatusEnumDTO
  /**
  */
  title?: string;
  /**
  */
  remark?: string;
  /**
  */
  projectNumber?: string;
  /**
  */
  clientCompanyName?: string;
  /**
  */
  clientAddressLine?: string;
  /**
  */
  clientPostalCode?: string;
  /**
  */
  clientCity?: string;
  /**
  */
  clientFirstName?: string;
  /**
  */
  clientLastName?: string;
  /**
  */
  clientEMail?: string;
  /**
  */
  clientPhoneNumber?: string;
  /**
  */
  addressLine?: string;
  /**
  */
  city?: string;
  /**
  */
  postalCode?: string;
  /**
  * @type {date-time}
  */
  nextInspectionDueDate?: string;

  static toModel(dto: DeepPartial<SiHaDocumentationListDTO>): SiHaDocumentationListModel;
  static toModel(dto: DeepPartial<SiHaDocumentationListDTO> | undefined | null): SiHaDocumentationListModel | undefined;
  static toModel(dto: DeepPartial<SiHaDocumentationListDTO> | undefined | null): SiHaDocumentationListModel | undefined {
    return dto ? new SiHaDocumentationListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SiHaDocumentationListModel> | SiHaDocumentationListModel): SiHaDocumentationListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      siHaDocumentationStatus: unwrapped.siHaDocumentationStatus,
      title: unwrapped.title,
      remark: unwrapped.remark,
      projectNumber: unwrapped.projectNumber,
      clientCompanyName: unwrapped.clientCompanyName,
      clientAddressLine: unwrapped.clientAddressLine,
      clientPostalCode: unwrapped.clientPostalCode,
      clientCity: unwrapped.clientCity,
      clientFirstName: unwrapped.clientFirstName,
      clientLastName: unwrapped.clientLastName,
      clientEMail: unwrapped.clientEMail,
      clientPhoneNumber: unwrapped.clientPhoneNumber,
      addressLine: unwrapped.addressLine,
      city: unwrapped.city,
      postalCode: unwrapped.postalCode,
      nextInspectionDueDate: unwrapped.nextInspectionDueDate,
    } as SiHaDocumentationListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SiHaDocumentationListModel, can not map to SiHaDocumentationListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
